module.exports = __webpack_public_path__ + "static/img/h_34@2x.400d52b7.png";